import webui from "@tinqin/tinqin-web-ui";
import { setApplicationBoot } from "@tinqin/tinqin-web-ui/src/actions/Application";

export default function loadAppBoot() {
    return async dispatch => {
        const triggerApplicationLoading = webui.getActionByName(
            "loading.triggerApplicationLoading"
        );
        dispatch(triggerApplicationLoading());
        dispatch(setApplicationBoot(true));
        try {
            const { BOOT } = webui.getWebConfig();
            await dispatch(
                webui.getActionByName("request.request")({
                    method: "POST",
                    endpoint: BOOT,
                    payload: {
                        address: window.location.pathname + window.location.search
                    },
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
            );

            await webui.getActionByName("locale.loadStaticTranslation")(dispatch);
            return Promise.resolve();
        } catch (error) {
            const triggerMessages = webui.getActionByName("messages.triggerErrorMessage");
            return dispatch(
                triggerMessages({
                    type: "error",
                    message: "Application failed to boot!"
                })
            );
        } finally {
            dispatch(setApplicationBoot(false));
            setTimeout(() => {
                dispatch(triggerApplicationLoading(false));
            }, 50);
        }
    };
}
